// @flow

import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import withPxc from 'app/hoc/withPxc';
import * as userActions from 'app/actions/userActions';
import * as rapidfireActions from 'app/actions/rapidfireActions';
import RapidFireTeamSelectionBase from './RapidFireTeamSelectionBase';

function mapStateToProps(state) {
  return {
    hasLightBackground: !state.settings.darkMode,
    upcomingChallenges: state.rapidfire.upcomingChallenges,
    isSignedIn: state.user.isSignedIn
  };
}

function mergeProps(
  { hasLightBackground, upcomingChallenges },
  dispatchProps,
  { competition, ...ownProps }
) {
  const selectedChallenge = upcomingChallenges.find(ch => ch.competitionId === competition.id);
  return {
    ...dispatchProps,
    ...ownProps,
    hasLightBackground,
    showHeader: true,
    matchUps: selectedChallenge.matchUps,
    fees: selectedChallenge.fees.find(
      section => `rapidfire_${ownProps.contestType}` === section.key
    ).value,
    challenges: selectedChallenge.challenges,
    startTime: selectedChallenge.startTime,
    statusId: selectedChallenge.status.id,
    statusLabel: selectedChallenge.status.name,
    competitionId: selectedChallenge.competitionId,
    challengeName: `${competition.name} ${ownProps.contestType}`,
    payStructure: selectedChallenge.payStructures.find(
      section => `rapidfire_${ownProps.contestType}` === section.key
    ).value,
    sportId: competition.sport_id
  };
}

const actions = {
  getCurrentUser: userActions.getCurrentUser,
  refreshData: rapidfireActions.getUpcoming
};

const enhancer = compose(withRouter, withPxc, connect(mapStateToProps, actions, mergeProps));

export default enhancer(RapidFireTeamSelectionBase);
